import { httpRequest } from "@/lib";
import { PatientsResponse } from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  search?: string | null;
};

async function fetchPatients({ search }: Props): Promise<PatientsResponse> {
  const response = await httpRequest.get<PatientsResponse>(
    `/patients?search=${search ?? ""}`
  );
  return response.data;
}

export function useSearchPatientsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchPatients,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] });
    },
  });
}
